import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getInsurancesRequest: null,
  getInsurancesSuccess: ['insurances'],
  getInsurancesFailure: ['error'],
  addInsuranceRequest: ['insurance', 'closeModal'],
  addInsuranceSuccess: ['insurance'],
  addInsuranceFailure: ['error'],
  updateInsuranceRequest: ['id', 'insurance', 'closeModal'],
  updateInsuranceSuccess: ['insurance'],
  updateInsuranceFailure: ['error'],
  removeInsuranceRequest: ['id'],
  removeInsuranceSuccess: ['id'],
  removeInsuranceFailure: ['error'],
});

export const InsurancesTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  insurances: [],
  isLoading: false,
  error: null,
});

/* Reducers */

const getInsurancesRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getInsurancesSuccess = (state, { insurances }) =>
  state.merge({
    insurances,
    isLoading: false,
  });

const getInsurancesFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addInsuranceRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addInsuranceSuccess = (state, { insurance }) =>
  state.merge({
    insurances: [...state.insurances, insurance],
    isLoading: false,
  });

const addInsuranceFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateInsuranceRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateInsuranceSuccess = (state, { insurance }) =>
  state.merge({
    insurances: state.insurances.map((item) =>
      item.id === insurance.id ? insurance : item
    ),
    isLoading: false,
  });

const updateInsuranceFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeInsuranceRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeInsuranceSuccess = (state, { id }) =>
  state.merge({
    insurances: state.insurances.filter((item) => item.id !== id),
    isLoading: false,
  });

const removeInsuranceFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_INSURANCES_REQUEST]: getInsurancesRequest,
  [Types.GET_INSURANCES_SUCCESS]: getInsurancesSuccess,
  [Types.GET_INSURANCES_FAILURE]: getInsurancesFailure,
  [Types.ADD_INSURANCE_REQUEST]: addInsuranceRequest,
  [Types.ADD_INSURANCE_SUCCESS]: addInsuranceSuccess,
  [Types.ADD_INSURANCE_FAILURE]: addInsuranceFailure,
  [Types.UPDATE_INSURANCE_REQUEST]: updateInsuranceRequest,
  [Types.UPDATE_INSURANCE_SUCCESS]: updateInsuranceSuccess,
  [Types.UPDATE_INSURANCE_FAILURE]: updateInsuranceFailure,
  [Types.REMOVE_INSURANCE_REQUEST]: removeInsuranceRequest,
  [Types.REMOVE_INSURANCE_SUCCESS]: removeInsuranceSuccess,
  [Types.REMOVE_INSURANCE_FAILURE]: removeInsuranceFailure,
});
